export default "__VITE_ASSET__b9626dd8__"